import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAdminProfile } from "../../store/slices/authSlice";

const ProtectedRoute = ({ children, requireAdmin = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, isAdmin, isLoading, admin, user } = useSelector(
    (state) => state.auth,
  );

  // Check localStorage directly
  const token = localStorage.getItem("accessToken") || localStorage.getItem("adminToken");
  const isAdminAuth = localStorage.getItem("isAdminAuthenticated") === "true";
  const adminData = localStorage.getItem("admin");
  const userData = localStorage.getItem("user");

  useEffect(() => {
    // If we have token but no admin data in Redux, fetch profile
    if (token && !isAuthenticated && !isLoading && !admin && isAdminAuth) {
      dispatch(getAdminProfile());
    }
  }, [token, isAuthenticated, isLoading, admin, isAdminAuth, dispatch]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Check if user is authenticated (non-admin) - redirect to user dashboard
  if (user && !isAdmin && !isAdminAuth && userData) {
    console.log("ProtectedRoute - User trying to access admin routes, redirecting to user dashboard");
    return <Navigate to="/user" state={{ from: location }} replace />;
  }

  // Check admin authentication from both Redux and localStorage
  const isAdminAuthValid = (isAuthenticated && isAdmin) || (token && adminData && isAdminAuth);

  if (!isAdminAuthValid) {
    console.log("ProtectedRoute - Not authenticated as admin, redirecting to login");
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // For admin routes, verify admin status
  if (requireAdmin && !isAdmin && !isAdminAuth) {
    console.log("ProtectedRoute - Not admin, redirecting to home");
    return <Navigate to="/" replace />;
  }

  console.log("ProtectedRoute - Admin access granted");
  return children ? children : <Outlet />;
};

export default ProtectedRoute;